module.exports = __webpack_public_path__ + "static/media/authorizationformat.393ac218.pdf";